export const addFloats = (str1: string, str2: string): number => {
  const num1 = parseFloat(str1);
  const num2 = parseFloat(str2);

  if (isNaN(num1) || isNaN(num2)) {
    throw new Error(
      'Invalid input: Both arguments must be convertible to float numbers.',
    );
  }

  return num1 + num2;
};

export const toFixedFloat = (num: number | undefined, decimals = 2): string => {
  if (num && typeof num === 'number') {
    return num.toFixed(decimals);
  } else {
    return '0.00';
  }
};

export const calculatePrices = (
  finalPrice: number,
  quantity: number,
  shippingPrice: number,
) => {
  const unitPrice = Number(
    Number((finalPrice * 100) / (quantity || 1)).toFixed(2),
  );

  const totalAmount = Number(
    Number(unitPrice * Number(quantity) + Number(shippingPrice) * 100).toFixed(
      0,
    ),
  );

  return {
    unitPrice,
    totalAmount,
  };
};

export const normalizeFloat = (num: number) => {
  const strNum = num.toFixed(2);
  return parseFloat(strNum);
};
